import toponimi from "../static/resources/toponimiGrouped.json";

const MAX_TOPONIMO_LENGTH = 4;

export const getToponimoFromAddress = address => {
    console.log(toponimi, address);
    if (!address || address.length === 0) return null;

    const addressToUpperCase = address.toUpperCase();
    const addressSplitArray = addressToUpperCase.split(' ');
    const maxLength = addressSplitArray.length > MAX_TOPONIMO_LENGTH ? MAX_TOPONIMO_LENGTH : addressSplitArray.length;

    const toponimiToSearchFrom = toponimi[addressSplitArray[0].charAt(0)];
    if (!toponimiToSearchFrom) return null;

    for (let i = maxLength - 1; i >= 0; i--) {
        let stringToSearch = '';
        for (let s = 0; s <= i; s++) {
            stringToSearch += addressSplitArray[s] + ' ';
        }
        stringToSearch = stringToSearch.trim();

        const match = toponimiToSearchFrom.find(t => t.TOP_DESCRIZIONE_BREVE === stringToSearch);
        if (match) {
            if (match.TOP_DESCRIZIONE_BREVE === address.toUpperCase()) {
                console.log("Match is exactly the same as the address, skipping");
            } else {
                match.parsedAddress = address.split(' ').slice(i + 1).join(' ');
                match.code = match.TOP_TOPONIMO_COD;
                match.description = match.TOP_DESCRIZIONE_BREVE;
                console.log('Toponimo found match', match);
                return match;
            }
        }
    }

    console.log('Toponimo match not found');
    return null;
}

export const getFullPlaceNameFromDescription = description => {
    if (!description || description.length === 0) return null;
    description = description.toUpperCase();
    const firstChar = description.charAt(0);
    const placeNamesToSearchFrom = toponimi[firstChar];
    if (!placeNamesToSearchFrom) return null;
    return placeNamesToSearchFrom.find(pn => pn.TOP_DESCRIZIONE_BREVE === description) || null;
}

export const getFullPlaceNameFromCode = code => {
    const toponimiKeys = Object.keys(toponimi);
    for (let toponimoKey of toponimiKeys) {
        const match = toponimi[toponimoKey].find(t => t.TOP_TOPONIMO_COD === code);
        if (match) return match;
    }
    return null;
}